import React from 'react';
import * as reactUtils from '../../packages/react-utils/react-utils.js';
import * as propsUtils from '../../packages/props-utils/props-utils.js';
import '../../packages/props-utils/prop-types.js';

/**
 * Enhances Icon or Button with Input class names depending on the component type.
 * @param icon Icon or Button component
 * @param extraClasses classNames to inject on the icon
 * @returns Enhanced Icon or Button component for Input component
 */
function handleIcon(icon, extraClasses) {
  if (reactUtils.isOfType(icon, 'Button')) {
    return /*#__PURE__*/React.cloneElement(icon, {
      display: 'square',
      appearance: 'link',
      size: 'sm',
      extraClasses: propsUtils.handleExtraClasses(icon, extraClasses)
    });
  }
  if (reactUtils.isOfType(icon, 'Icon')) {
    return /*#__PURE__*/React.cloneElement(icon, {
      extraClasses: propsUtils.handleExtraClasses(icon, extraClasses),
      size: 4
    });
  }
  return icon;
}
function iconValidator() {
  return _ref => {
    let {
      iconLeft,
      iconRight
    } = _ref;
    if (iconLeft && !reactUtils.isOfType(iconLeft, 'Icon') && !reactUtils.isOfType(iconLeft, 'Button')) {
      return new Error("Input component only accepts \"Icon\" or \"Button\" component as iconLeft, but received ".concat(reactUtils.getElementName(iconLeft), "."));
    }
    if (iconRight && !reactUtils.isOfType(iconRight, 'Icon') && !reactUtils.isOfType(iconRight, 'Button')) {
      return new Error("Input component only accepts \"Icon\" or \"Button\" component as iconRight, but received ".concat(reactUtils.getElementName(iconRight), "."));
    }
    return null;
  };
}

export { handleIcon, iconValidator };
